import { mark } from './PerformanceService';
import { fluidPerformanceMarker } from './PerformanceServiceStates';
export function markFluidBootPerformance(correlationId, bootId) {
    var _a;
    var instrumentationParams = (_a = {},
        _a["ResourceId" /* InstrumentationParam.ResourceId */] = correlationId,
        _a);
    var clickTimeMarker = mark("FluidContentPerformanceMarker.DocumentLoadStart.".concat(bootId), 0 /* PerformanceMeasureType.NoMeasure */, undefined, instrumentationParams);
    if (clickTimeMarker) {
        fluidPerformanceMarker.set(bootId, {
            clickTimeMarker: clickTimeMarker,
            instrumentationParams: instrumentationParams,
        });
    }
}
//# sourceMappingURL=logPerformanceBoot.js.map